/**
 * Cart Configurator - Handle grouped item removal
 * When a main product is removed, also remove its linked addon products
 */
(function() {
  document.addEventListener('DOMContentLoaded', initCartConfigurator);
  document.addEventListener('shopify:section:load', initCartConfigurator);

  function initCartConfigurator() {
    const removeButtons = document.querySelectorAll('.js-cart-item-remove[data-group-id]');
    
    removeButtons.forEach(button => {
      button.addEventListener('click', handleGroupedRemoval);
    });
  }

  async function handleGroupedRemoval(e) {
    const button = e.currentTarget;
    const groupId = button.dataset.groupId;
    
    if (!groupId) return;
    
    e.preventDefault();
    
    const groupsDataEl = document.getElementById('cart-groups-data');
    if (!groupsDataEl) {
      window.location.href = button.href;
      return;
    }
    
    try {
      const groupsData = JSON.parse(groupsDataEl.textContent);
      const itemsToRemove = [];
      
      for (const [itemKey, itemGroupId] of Object.entries(groupsData.groups)) {
        if (itemGroupId === groupId) {
          itemsToRemove.push(itemKey);
        }
      }
      
      if (itemsToRemove.length === 0) {
        window.location.href = button.href;
        return;
      }
      
      const updates = {};
      itemsToRemove.forEach(key => {
        updates[key] = 0;
      });
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: updates })
      });
      
      if (!response.ok) {
        throw new Error('Failed to update cart');
      }
      
      window.location.reload();
      
    } catch (error) {
      console.error('Error removing grouped items:', error);
      window.location.href = button.href;
    }
  }
})();